import React from 'react'

import LeaseList from '../../components/Leases/LeaseList.jsx'
import { leases } from '../../core/controllers/Leases'
import NavLink from '../../components/Routes/NavLink';
import CardHolder from '../../helpers/Cards/CardHolder';
import {
    ExpiringLeases,
    VacantLeases,
    AwaitingESig,
    TotalLeases
} from '../../helpers/Cards/Cards';

export default class LeasesTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortID : "0",
            filter: null,
            leaseData: null,
            leaseDataFiltered: false
        };
    }

    componentDidMount() {
        var self = this;
        leases.getLeases(this.state.sortID, null, function(response) {
            self.props.filter && self.props.filter.filter
                ? self.updateFilter(
                    self.props.filter.filter,
                    (filterData, type) => self.setState({
                        filter: type,
                        leaseData: response.data,
                        leaseDataFiltered: filterData,
                    })
                )
                : self.setState({leaseData: response.data});
        });
    }

    // #  Triggers documents to be called, belonging to tenant
    sortTenantSelect(e) {
        this.setState({
            sortID: e.target.value
        });
    }

    updateFilter(type, callback) {
        var self = this;
        leases.getLeases(this.state.sortID, type, function(response) {
            if (callback) {
                callback(response.data, type);
            } else {
                self.setState({
                    leaseDataFiltered: self.state.filter == type ? false : response.data,
                    filter: self.state.filter == type ? null : type
                });
            }
        });
    }

    render(){
        const changeFilterToExpiring = () => this.updateFilter('expiring');
        const changeFilterToVacant = () => this.updateFilter('vacancies');
        const hasFilter = this.state.filter != null;
        var expiring = '';
        var vacancies = '';
        var selected = this.state.filter;

        if (selected != null) {
            if (selected == 'expiring') {
                expiring = 'checked';
            } else {
                vacancies = 'checked';
            }
        }
        return (
            <div>
                {this.state.leaseData != null ? (
                <div>
                    <div class="row">
                        <div class="main-page-header-row col-md-12">
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <span class="main-page-header-title">Leases</span>
                            </div>
                            <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-6">
                                <NavLink to={"/lease/new"}>
                                    <button type="button" id="add-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                        Add Lease
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <CardHolder width="100%" columnCount={4} paddingWidth={15}>
                        <AwaitingESig clickable={true} />
                        <ExpiringLeases clickable={false}/>
                        <VacantLeases clickable={false}/>
                        <TotalLeases />
                    </CardHolder>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-title card">
                                <div class="header col-md-3 col-sm-12 col-xs-12">
                                    <h4 class="title">Leases</h4>
                                    <p class="category">Complete list of all leases</p>
                                </div>
                                <div class="filter-options search-overlap col-md-8 col-sm-12 col-xs-12">
                                    <label class="filter-checkbox-container">Expiring Lease
                                        <input type="checkbox" class="filter-checkbox" checked={expiring} onClick={changeFilterToExpiring}/>
                                    </label>
                                    <label class="filter-checkbox-container">Vacancies
                                        <input type="checkbox" class="filter-checkbox" checked={vacancies} onClick={changeFilterToVacant}/>
                                    </label>
                                    {/* { selected != null && (
                                        <span class="clickable-action" onClick={this.updateFilter.bind(this, null)}>reset table</span>
                                    )} */}
                                </div>
                                <LeaseList leaseData={hasFilter ? (this.state.leaseDataFiltered) : (this.state.leaseData)}/>
                            </div>
                        </div>
                    </div>
                </div>
                ) : (
                    <div>
                        <div class="content" style={{textAlign: "center"}}>
                            <div class="row">
                                <div class="main-page-header-row col-md-12">
                                    <div class="row">
                                        <span class="main-page-header-title">No Leases Yet</span>
                                    </div>
                                    <div class="row" style={{marginTop: "10px"}}>
                                        <NavLink to={"/lease/new"}>
                                            <button type="button" id="add-lease" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                                Add Lease
                                            </button>
                                            <div class="clearfix"></div>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12" style={{backgroundImage: "url('/assets/img/lease.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '500px'}}></div>
                    </div>
                )}
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Leases/Leases.jsx